<template>
    <div class="row" v-if="videoPackageItem && videoPackageItem.material">
        <div class="col">
            <h4 class="h4 text-center my-4" v-html="videoPackageItem.material.title"></h4>
            <div class="row">
                <div class="col">
                    <!--<component :is="currentComponent" v-bind="currentProperties"></component>-->
                    <div class="row">
                        <div class="col-6 mx-auto">
                            <video-frame v-if="videoPackageItem.url_vimeo" :url="videoPackageItem.url_vimeo"></video-frame>
                            <video-frame v-else-if="videoPackageItem.url_youtube" :url="videoPackageItem.url_youtube"></video-frame>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'video-widget',
        props: {
            videoPackageItem: { type: [Object], default: null, required: false },
        },
    }
</script>

<style scoped>

</style>
